const transactionFeePriceRangeList = [
    {
        id: "100",
        name: "0% - 0.99%",
        type: "percentage"
    },
    {
        id: "101",
        name: "1% - 3.99%",
        type: "percentage"
    },
    {
        id: "103",
        name: "4% - 6.99%",
        type: "percentage"
    },
    {
        id: "104",
        name: "7% - 9.99%",
        type: "percentage"
    },
    {
        id: "105",
        name: "10% or more",
        type: "percentage"
    }
]
   
   
   module.exports = { transactionFeePriceRangeList };